const app = (state = {}, action) => {
    switch (action.type) {
        case 'ADMIN_CATALOG_SETPARAMS': {
            const payload = action.payload;

            return {
                ...state,
                ...payload,
            };
        }

        case 'ADMIN_CATALOG_LOADED': {
            const payload = action.payload;

            return {
                ...state,
                ...payload,
            };
        }

        default: {
            return state;
        }
    }
};

export default app;
